import api from '../../../utils/api'

import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'



/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'

/* form */
import FormServiceOrder from './Form/FormServiceOrder'

function NewServiceOrder({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()
    const navigate = useNavigate()

    

    async function registerServiceOrder(serviceOrder) {
        let msgType = 'success'

        const data = await api.post('/serviceOrder/new', serviceOrder, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <section>
            <FormServiceOrder
                title="Nova Ordem de Serviço"
                handleSubmit={registerServiceOrder}
                btCancelAction={btCancelAction}
            />
        </section>
    )
}

export default NewServiceOrder